import styled from 'styled-components';

export default styled.div.attrs({ role: 'row' })`
  display: flex;
`;
